import { Component, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { AlertComponent } from '@components/alert/alert.component';
import { DashboardMenuComponent } from '@components/dashboard-menu/dashboard-menu.component';
import { LoadingAlertComponent } from '@components/loading-alert/loading-alert.component';
import { PopoverOptionsComponent } from '@components/popover-options/popover-options.component';
import { SidePanelWrapperComponent } from '@components/side-panel-wrapper/side-panel-wrapper.component';
import { ToastComponent } from '@components/toast/toast.component';
import { AlertService } from '@services/alert.service';
import { LoadingService } from '@services/loading.service';
import { PopoverService } from '@services/popover.service';
import { SidePanelService } from '@services/side-panel.service';
import { filter } from 'rxjs';

@Component({
  imports: [
    AlertComponent,
    DashboardMenuComponent,
    LoadingAlertComponent,
    PopoverOptionsComponent,
    RouterOutlet,
    SidePanelWrapperComponent,
    ToastComponent,
  ],
  selector: 'app-root',
  styleUrl: './app.component.scss',
  templateUrl: './app.component.html',
})
export class AppComponent {
  protected alert = inject(AlertService).get();
  protected isAppReady = signal(false);
  protected isDashboardRoute = signal(false);
  protected isMaintenanceMode = signal(false);
  protected loading = inject(LoadingService).get();
  protected popover = inject(PopoverService).get();
  protected sidePanels = inject(SidePanelService).get();
  private router = inject(Router);

  constructor() {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      takeUntilDestroyed(),
    ).subscribe((event) => {
      const dashboardPath = event.urlAfterRedirects.split('?')[0] ?? '';
      this.isDashboardRoute.set(dashboardPath.startsWith('/dashboard'));
      this.isAppReady.set(true);
    });
  }
}
